import { GeoPoint, Timestamp } from '@angular/fire/firestore';

export enum JobStatus {
  JOB_CREATED = 'JOB_CREATED',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP',
  PICKED_UP_BY_AGENT = 'PICKED_UP_BY_AGENT',
  ACCEPTED = 'ACCEPTED',
  DELIVERED = 'DELIVERED',
  REJECTED = "REJECTED"
}

export class Job {
  constructor(
    public backendId: string,
    public distance: string,
    public destination: LocationDetails,
    public origin: LocationDetails,
    public timings: Timings,
    public orderId: string,
    public jobStatus: JobStatus,
    public potentialRiders: PotentialRider[],
    public assignedRiderId: string,
    public searchParams: SearchParam[],
    public deliveryCharge: DeliveryCharge,
    public tipAmount: number
  ) {}
}

export class LocationDetails {
  constructor(
    public name: string | undefined,
    public primaryContact: string | undefined,
    public secondaryContact: string | undefined,
    public address: Address | undefined,
    public location: GeoPoint | undefined,
    public emailId: string | undefined
  ) {}
}

export class Timings {
  constructor(
    public orderPlacedAt: Timestamp | undefined,
    public orderPickedUpAt: Timestamp | undefined,
    public orderDeliveredAt: Timestamp | undefined,
    public orderUpdatedAt: Timestamp | undefined
  ) {}
}

export class Address {
  constructor(
    public line1: string | undefined,
    public line2: string | undefined,
    public city: string | undefined,
    public state: string | undefined,
    public country: string | undefined,
    public zipCode: string | undefined
  ) {}
}

export class PotentialRider {
  constructor(
    public riderId: string | undefined,
    public status: string | undefined,
    public location: GeoPoint | undefined
  ) {}
}

export class SearchParam {
  constructor(
    public city: string | undefined,
    public range: number | undefined
  ) {}
}

export class DeliveryCharge {
  constructor(
    public baseFee: number,
    public tax: number,
    public total: number
  ) {}
}

export class DeliveryDetails {
  job?: OrderJob;
  riderDetails?: OrderRider;
}

export class OrderJob {
  id?: string;
  orderId?: string;
  jobDate?: string;
  assignedRiderId?: string;
  jobStatus?: JobStatus;
}

export class OrderRider {
  id?: string;
  name?: string;
  primaryContact?: string;
}